/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleTier extends models.Tier {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleTier");
    }

    getFixupPrototypeFunction() { return BillingRuleTier.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleTier>): BillingRuleTier {
        let obj = Object.assign(new BillingRuleTier(), model);
        BillingRuleTier.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleTier>): BillingRuleTier {
        if (!model) return null;
        return BillingRuleTier.newInstance(<BillingRuleTier> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleTier) {
        if (!obj) return;

        models.BillingRuleTier.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleTier): boolean {
        if (models.Tier.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleTier.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.rule) {
            models.BillingRule.fixupPrototype(this.rule);
        }
    }

    /**
     * Rule for the tier. Nested Tiered Rules are not allowed.
     */
    rule: models.BillingRule;

}
